export const MUSICAL_KEYS = [
  'C maj', 'C# maj', 'D maj', 'Eb maj', 'E maj', 'F maj',
  'F# maj', 'G maj', 'Ab maj', 'A maj', 'Bb maj', 'B maj',
  'C min', 'C# min', 'D min', 'Eb min', 'E min', 'F min',
  'F# min', 'G min', 'Ab min', 'A min', 'Bb min', 'B min',
];

export default MUSICAL_KEYS;
